<div class="dialog-wrapper">
    <h1 mat-dialog-title class="text-center">
        <span class="svg-icon svg-icon-primary svg-icon-6x"
            ><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect x="0" y="0" width="24" height="24" />
                    <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
                    <path
                        d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z"
                        fill="#000000"
                    />
                </g></svg
        ></span>
    </h1>
    <div mat-dialog-content class="text-center">
        <p class="notification-title" #message>{{ modalMessage }}</p>
    </div>
    <div mat-dialog-content class="text-center">
        <p class="notification-title" #warning>{{ modalWarningMessage }}</p>
    </div>
    <div mat-dialog-actions class="text-center">
        <button mat-button class="me-5 btn primary-ebtn font-weight-bold" (click)="closeDialogWithResult()">
            {{ buttonText ? buttonText : ('SETTING_PAGE.IDMS_SETTINGS.DELETE' | transloco) }}
        </button>
        <button mat-button class="btn secondary-ebtn" (click)="closeDialogWithCancel()">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
    </div>
</div>
